export const FeatureToken = 'FeatureToken';
